var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gol-tipster-v2"},[_c('div',{staticClass:"gol-tipster-v2__container"},[_c('GolTipsterV2')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }